<template>
  <ProjectForm
    title="Edit Project"
    :project="project"
    :main-error="mainError"
    :inputs-errors="inputsErrors"
    :project-code="projectCode"
    @submit="submit"
  />
</template>

<script>
import { mapState } from 'vuex';
import ProjectForm from './project-form';

const UNEXPECTED_ERORR = {
  details: 'Something went wrong',
  code: 'unexpected.error'
};
export default {
  name: 'ProjectEdit',
  components: { ProjectForm },
  props: ['projectCode'],
  data() {
    return {
      mainError: null,
      inputsErrors: []
    };
  },
  computed: {
    ...mapState({
      project: state => state.projectSubstations.project
    })
  },
  mounted() {
    this.$store.dispatch('projectSubstations/fetchData', {
      projectCode: this.projectCode
    });
  },
  destroyed() {
    this.$store.commit('projectSubstations/resetStore');
  },
  methods: {
    async submit(data) {
      const { name, timeZone, telegramChannelActive, telegramAuthToken, telegramChannelId } = data;

      const editParameters = {
        code: this.projectCode,
        data: {
          name,
          timeZone,
          telegramChannelActive,
          telegramAuthToken,
          telegramChannelId
        }
      };
      const response = await this.$store.dispatch('project/edit', editParameters);

      if (response.status === 422) {
        this.inputsErrors = response.body.errors;

        return false;
      }
      if (response.status !== 200) {
        this.inputsErrors = [UNEXPECTED_ERORR];

        return false;
      }
      this.$store.dispatch('projects/fetchData');
      this.$router.replace('/projects');

      return true;
    }
  }
};
</script>
